import { useLoading } from 'react-simplikit';

import { useScrapingJobs } from '../../hooks/use-scraping-jobs';

import { internalApiClient } from '@/shared/api-client/internal-api-client';
import { RingSpinner } from '@/shared/components/loader/ring-spinner';
import { Button } from '@/shared/components/shadcn/button';

interface Props {
  scrapingJobId: string;
}

async function deactivateScrapingJob(scrapingJobId: string) {
  try {
    await internalApiClient.put(`social-post-scraping-jobs/${scrapingJobId}/deactivate`);
  } catch (error) {
    console.error(`Failed to deactivate scraping job ${scrapingJobId}:`, error);
    throw error; // Re-throw to handle in component
  }
}

export function DeactivateScrapingJobButton({ scrapingJobId }: Props) {
  const [isLoading, startLoading] = useLoading();

  const handleDeactivate = async () => {
    const confirmed = confirm('Are you sure you want to deactivate this scraping job?');
    if (!confirmed) {
      return;
    }

    if (isLoading) {
      return;
    }

    await startLoading(
      (async () => {
        await deactivateScrapingJob(scrapingJobId);
        await useScrapingJobs.refetch('GOOGLE_SEARCH');
      })(),
    );
  };

  return (
    <Button
      className="min-w-16"
      variant="destructive"
      disabled={isLoading}
      onClick={handleDeactivate}
    >
      {isLoading ? <RingSpinner /> : 'Stop'}
    </Button>
  );
}
